export const drawArray = (obj, ctxt, size, color, pts) => {
    ctxt.fillStyle = color;
    for (let i=0; i < pts.length; i+=2) {
        let x = pts[i];
        let y = pts[i+1];
        if (x > obj.zObject.width || y > obj.zObject.height) {
            continue;
        }
        ctxt.beginPath();
        let modX = x % size;
        //if (modX < size / 2) {
        x = x - modX;
        //} else {
        x = x + (size - modX);
        //}

        let modY = y % size;
        //if (modY < size / 2) {
        y = y - modY;
        //} else {
        //    y = y + (size - modY);
        //}
        ctxt.rect(x,y,size,size);
        ctxt.fill();
    }
};

export const drawTriangles = (obj, ctxt, color, triangles) => {
    if (window.arrDebug) {
        return;
    }
    ctxt.strokeStyle = color;

    for (let i=0; i <  triangles.length; i+=6) {
        ctxt.beginPath();
        ctxt.moveTo(triangles[i], triangles[i+1]);
        ctxt.lineTo(triangles[i+2], triangles[i+3]);
        ctxt.lineTo(triangles[i+4], triangles[i+5]);
        ctxt.stroke();
    }
};

